export default "__VITE_ASSET__a10f2735__"